import { ListDataProps } from 'store/interfaces';

const isChecked = (value: string, checked: string[]): boolean =>
  checked.includes(value);

const handleToggle = (
  value: string,
  setChecked: React.Dispatch<React.SetStateAction<string[]>>
) =>
  setChecked(prev =>
    prev.includes(value)
      ? prev.filter(item => item !== value)
      : [...prev, value]
  );

const handleToggleAll = (
  event: React.ChangeEvent<HTMLInputElement>,
  data: ListDataProps | null,
  setChecked: React.Dispatch<React.SetStateAction<string[]>>
) =>
  setChecked(
    event.target.checked && data ? data?.results.map(({ uuid }) => uuid) : []
  );

export const handleCheck = {
  exists: (value: string, checked: string[]) => isChecked(value, checked),
  toggle: (
    value: string,
    setChecked: React.Dispatch<React.SetStateAction<string[]>>
  ) => handleToggle(value, setChecked),
  toggleAll: (
    event: React.ChangeEvent<HTMLInputElement>,
    data: ListDataProps | null,
    setChecked: React.Dispatch<React.SetStateAction<string[]>>
  ) => handleToggleAll(event, data, setChecked),
};
